<template>
  <div>
    <div class="row row-0">
      <div class="col-sm-6">
        <img src="../assets/images/ca5s1bg.jpg" alt="" class="img-fluid img-bg">
        <div class="floating-quote">
          <div>
            Réussir à fidéliser sa clientèle est une étape cruciale de votre développement commercial.
          </div>
        </div>
      </div>
      <div class="col-sm-6 cyan-bg align-middle">
        <div>
          <div class="ca5-section1-content-w">
            <div class="text-center">
              <h2>
                le Livre Blanc
              </h2>
              <p class="bigger-p">
                des clés de la
                fidélisation clients !
              </p>
              <p>
                <i>
                  Découvrez comment fidéliser vos clients pour générer plus de revenus
                  en téléchargeant notre Livre Blanc
                </i>
              </p>
              <p>
                <a href="#" class="the-button" @click.prevent="download">
                  télécharger
                </a>
              </p>
            </div>
            <div>
              <img src="../assets/images/ca5s1picture.png" class="img-fluid" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    download () {
      this.$scrollTo('#ca5-section3', 1000, { easing: 'ease', cancelable: false })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Download.vue